import SelectInput from 'components/SelectInput/SelectInput';
import React from 'react';

export default function LoadingSelectInput() {
  return <SelectInput options={[]} defaultValue={{ label: 'Loading...' }} isDisabled />;
}
